import React from 'react';
import PropTypes from 'prop-types';

function IconOrderBy({ asc }) {
  return (
    <svg width={8} height={8} viewBox={`0 0 256 256`} xmlns="http://www.w3.org/2000/svg">
      { asc
        ? <path d="M124.965 66.536L9.536 181.964c-3.15 3.15-.919 8.536 3.535 8.536h230.857c4.455 0 6.687-5.386 3.536-8.536L132.036 66.536a4.984 4.984 0 0 0-3.536-1.465c-1.28 0-2.56.488-3.535 1.465z" fill={`#9B9B9B`} fillRule={`evenodd`} />
        : <path d="M131.035 189.464L246.464 74.036c3.15-3.15.919-8.536-3.535-8.536H12.072c-4.455 0-6.687 5.386-3.536 8.536l115.428 115.428a4.984 4.984 0 0 0 3.536 1.465c1.28 0 2.56-.488 3.535-1.465z" fill={`#9B9B9B`} fillRule={`evenodd`} />
      }
    </svg>
  )
}

IconOrderBy.propTypes = {
  asc: PropTypes.bool.isRequired
}

export default IconOrderBy;
